export default class Filter {
    static Type = {
        Select: 'Select',
        Collection: 'Collection',
        Scalar: 'Scalar',
        Date: 'Date',
        String: 'String',
        ScalarDate: 'ScalarDate'
    }

    type = null

    constructor(type) {
        this.type = type
    }
}